import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../axios/axiosInstance';


export const fetchCallHistoryAgent = createAsyncThunk(
  'callHistory/fetchCallHistoryAgent',
  async (payload, { rejectWithValue }) => {
    try {
        const response = await api.post('/call/agent-call-history', payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const CallHistoryAgentSlice = createSlice({
  name: 'callHistoryAgent',
  initialState: {
    loading: false,
    data: [],
    pagination: {
      page: 1,
      page_size: 10,
      total: 0,
    },
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCallHistoryAgent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCallHistoryAgent.fulfilled, (state, action) => {
        state.loading = false;

        state.data = action.payload.callRecords || [];

        state.summary = action.payload.summary || {};

        state.pagination = {
          page: action.payload.page || 1,
          page_size: action.payload.page_size || 10,
          total: action.payload.totalRecords || 0,
        };

        state.error = null;
      })
      .addCase(fetchCallHistoryAgent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Something went wrong';
      });
  },
});

export default CallHistoryAgentSlice.reducer;
